/**
*@Time : 2020/9/2 下午4:03
*@Author : Hejie Shao
*/
<template>
  <footer class="footer" :icp="icps" :style= "textStyle">
    版权所有：杭州哈匹科技有限公司 | 电子营业执照：<a href="https://beian.miit.gov.cn" :style= "textStyle">{{icps}}</a> |
    <div class="gongan">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602011031">
        <img
        src="@/assets/beian.png" class="beian-logo" style="float:left;"/>
        <p :style= "textStyle">浙公网安备 33010602011031号</p></a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footer",
  props: {
    pageName:String,
    textColor:String,
    icp:String
  },
  data() {
    return {}
  },
  computed:{
    icps(){
      return this.icp
    },

    textStyle(){
      return 'color:' + this.textColor + ';'
    },

    pageName(){
      return this.pageName
    }
  },
  components: {},
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss">
@import "~@/assets/scss/globalFn.scss";

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: cs(30);
  text-align: center;
  font-size: 12px;
  //color: rgba(255, 255, 255, 1);
  z-index: 2;

  a {
    text-decoration: none;
    //color: rgba(255, 255, 255, 1);
  }

  .gongan {
    position: relative;
    top: 4px;
    margin: 0 auto;
    display: inline-block;

    a {
      display: flex;
    }

    img {
      vertical-align: middle;
    }

    p {
      position: relative;
      top: 2px;
      padding: 0;
      line-height: 20px;
      margin: 0;
      vertical-align: middle;
    }
  }
}
</style>
